export default {
  strict: true,
  namespaced: true,
  state: {
    transactions: {
      list: [],
      isMax: false,
      currentPage: 1,
      perPage: 20,
      maxList: 0,
      search: '',
      status: '',
      date: 'withinDay',
      dateFrom: '',
      dateTo: '',
      sort: {
        order: 'created',
        isDesc: true
      },
      loading: false
    }
  },
  mutations: {
    resetTransactions (state) { state.transactions.list = [] },
    addTransactions (state, value) { state.transactions.list.push(value) },
    setTransactionsIsMax (state, value) { state.transactions.isMax = value },
    setTransactionsCurrentPage (state, value) { state.transactions.currentPage = value },
    // setTransactionsFromTo (state, value) {
    //   state.transactions.from = value.from
    //   state.transactions.to = value.to
    // },
    resetFilters (state, value) {
      state.transactions.search = ''
      state.transactions.status = ''
      state.transactions.date = 'withinDay'
      state.transactions.dateFrom = ''
      state.transactions.dateTo = ''
      state.transactions.loading = false
    },
    setTrxSearch (state, value) { state.transactions.search = value },
    setTrxStatus (state, value) { state.transactions.status = value },
    setTrxDate (state, value) { state.transactions.date = value },
    setTrxDateFrom (state, value) { state.transactions.dateFrom = value },
    setTrxDateTo (state, value) { state.transactions.dateTo = value },
    setTrxSortColumn (state, value) { state.transactions.sort.column = value },
    setTrxSortIsDesc (state, value) { state.transactions.sort.isDesc = value },
    setTrxData (state, data) {
      for (let field in data) {
        state.transactions[field] = data[field]
      }
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/consumer/transactions.js